
import * as React from "react";
import Translate from "../../common/functions/translate";
import Spinner from '../../common/components/spinner/spinner';
import Snackbar from "../../common/components/snackbar/snackbar";
import LocalDataService from "../../services/localDataServices/localSynchronizationService";
import SynchronizationService from "../../services/synchronizationService";
import SynchronizationModel from "../../models/synchronization/synchronizationModel";
import AuthService from "../../services/authService";
import { getQueryParam } from "../../common/functions/helperFunctions";
import LocalOffersService from "../../services/localDataServices/localOffersService";
import AlertMessage from '../../common/components/alertMessage/alertMessage';
import { Button } from "@material-ui/core";
import UserService from '../../services/userService';

interface IProps {
    history: any;
    location: any;
}

interface IState {
    isLoading: boolean;
    isSynchronizing: boolean;
    error: any;
    dataForDb: SynchronizationModel;
}

class SynchronizationComponent extends React.Component<IProps, IState> {
    snackbar: any;
    authService = new AuthService();
    synchronizationService = new SynchronizationService();
    localDataService = new LocalDataService();
    localOffersService = new LocalOffersService();
    userService = new UserService();

    constructor(props: IProps) {
        super(props);

        this.state = {
            isLoading: false,
            isSynchronizing: false,
            error: null,
            dataForDb: new SynchronizationModel()
        };
    }

    componentDidMount() {
        this.setState({ isLoading: true });
        this.userService.getUser(this.authService.getUserId()).then(res => {
            this.setState({ isLoading: false });
            if (res.regionId !== this.authService.getRegionId()) {
                this.authService.getRefreshToken().then(r => {
                    this.synchronizationService = new SynchronizationService();
                    this.synchronize(true);
                }).catch(err => console.log(err));
            }
            else {
                this.setState({ isLoading: false });
                this.synchronize(false);
            }
        }).catch(error => this.setState({ isLoading: false, error: Translate(error.message) }));
    }

    synchronize = (isRegionChanged: boolean) => {
        this.setState({
            isSynchronizing: true,
            error: '',
        });

        // get offers for deletion
        this.localOffersService.getDeletedOffers().then(
            (deletedOffers: any) => {
                if (deletedOffers && deletedOffers.length > 0) {
                    // delete offers from server
                    this.synchronizationService.deleteOffers(deletedOffers).then(
                        () => {
                            // clear offers for deletion from local db
                            this.localOffersService.clearDeletedOffers().then(
                                () => {
                                    this.synchronizeOffersAndGetData(isRegionChanged);
                                }).catch(error => {
                                    console.log(error);
                                    this.synchronizeOffersAndGetData(isRegionChanged);
                                })
                        }).catch(error => {
                            console.log(error);
                            this.synchronizeOffersAndGetData(isRegionChanged);
                        })
                } else {
                    this.synchronizeOffersAndGetData(isRegionChanged);
                }
            }).catch(error => {
                console.log(error);
                this.synchronizeOffersAndGetData(isRegionChanged);
            })


    }

    synchronizeOffersAndGetData = (isRegionChanged: boolean) => {
        let isAfterLogin = false;

        if (this.props.location.search.includes('afterLogin')) {
            let afterLogin = getQueryParam(this.props.location.search, 'afterLogin');
            isAfterLogin = afterLogin === '1'
        }

        // get offers for synchronization
        this.localOffersService.getOffersForSynchronization().then(
            (offers: any) => {
                if (offers && offers.length > 0) {
                    // report offers to server
                    this.synchronizationService.reportOffers(offers).then(
                        (result: any) => {
                            // mark synchronized offers as reported
                            this.localOffersService.setOffersReported(offers).then(
                                () => {
                                    this.localOffersService.updateOffersRemoteIdentifiers(result).then(
                                        () => {
                                            this.getData(isRegionChanged);
                                        }
                                    ).catch(error => {
                                        if (isAfterLogin) {
                                            this.getData(isRegionChanged);
                                        } else {
                                            this.setState({
                                                isSynchronizing: false,
                                                error: Translate(error)
                                            });
                                            console.log(error);
                                        }
                                    });
                                }
                            ).catch(error => {
                                if (isAfterLogin) {
                                    console.log(error);
                                    this.getData(isRegionChanged);
                                } else {
                                    this.setState({
                                        isSynchronizing: false,
                                        error: Translate(error)
                                    });
                                    console.log(error);
                                }
                            });
                        }
                    ).catch(error => {
                        if (isAfterLogin) {
                            console.log(error);
                            this.getData(isRegionChanged);
                        } else {
                            this.setState({
                                isSynchronizing: false,
                                error: Translate(error)
                            });
                            console.log(error);
                        }
                    })
                } else {
                    this.getData(isRegionChanged);
                }
            }).catch(error => {
                this.setState({
                    isSynchronizing: false,
                    error: Translate(error)
                });
                console.log(error);
            });
    }

    getData = (isRegionChanged: boolean) => {
        let lastSyncDate = localStorage.getItem('lastSyncDate');
        let userId = localStorage.getItem('userId');

        //logged user is different from last sync user
        if (userId) {
            if (+userId !== this.authService.getUserId() || isRegionChanged) {
                lastSyncDate = null;
                this.localDataService.clearDatabase().then(
                    (result) => {
                        this.getDataFromAPI(lastSyncDate);
                    })
                    .catch(error => {
                        this.setState({
                            isSynchronizing: false,
                            error: Translate(error)
                        });
                        console.log(error);
                    });
            } else {
                this.getDataFromAPI(lastSyncDate);
            }
        } else {
            this.getDataFromAPI(lastSyncDate);
        }
    }

    getDataFromAPI = (lastSyncDate) => {
        this.synchronizationService.getData(lastSyncDate).then(
            (data: SynchronizationModel) => {
                if (data) {
                    this.setState({
                        dataForDb: data
                    }, () => this.insertData());
                }
            }
        ).catch(error => {
            this.setState({
                isSynchronizing: false,
                error: Translate(error.message)
            });
            console.log(error);
        });
    }

    insertData = () => {
        const { dataForDb } = this.state;

        if (dataForDb) {
            this.localDataService.loadData(dataForDb).then(
                () => {
                    this.redirectAfter();
                }
            ).catch(error => {
                this.setState({
                    isSynchronizing: false,
                    error: Translate(error)
                });
                console.log(error);
            })
        }
    }

    redirectAfter = () => {
        this.setState({
            isSynchronizing: false
        });

        if (this.props.location.search.includes('backUrl')) {
            var path = getQueryParam(this.props.location.search, 'backUrl');
            this.props.history.push(path);
        } else {
            this.props.history.push('/');
        }
    }

    public render() {
        const { isLoading, isSynchronizing, error } = this.state;

        return (
            <div >
                {isLoading ? <Spinner /> : null}
                <Snackbar ref={(el) => this.snackbar = el} />

                {isSynchronizing
                    ? <div style={{ textAlign: 'center' }}>
                        <div className="lds-facebook"><div></div><div></div><div></div></div>
                        <h3>{Translate('Data synchronization')}</h3>
                        <h3>{Translate('Please wait')}</h3>
                    </div>
                    : null}

                {error
                    ? <div style={{ width: '50%', margin: 'auto', marginTop: 30 }}>
                        <h3>{Translate('Data synchronization')}</h3>
                        <AlertMessage type='danger'>
                            {error}
                        </AlertMessage>
                        <Button variant="contained" color="primary" onClick={() => this.synchronize(false)}>
                            {Translate('Try again')}
                        </Button>
                    </div>
                    : null}



            </div>
        );
    }
}

export default SynchronizationComponent